/**
 * Rule that checks if diagram contains a step.
 */

const { is } = require("bpmnlint-utils");

module.exports = function stepsRequired({ ctx }) {
  let evaluated = false;

  return {
    check(node, reporter) {
      if (!node) return;
      if (evaluated) return;
      evaluated = true;

      const registry = ctx && ctx.elementRegistry;
      const elements = registry && typeof registry.getAll === "function" ? registry.getAll() : [];

      let hasStep = false;

      for (const el of elements) {
        if (!el) continue;

        const bo = el.businessObject || el;
        if (!bo) continue;

        if (
          is(bo, "bpmn:Task") ||
          is(bo, "bpmn:UserTask") ||
          is(bo, "bpmn:SubProcess") ||
          is(bo, "bpmn:CallActivity")
        ) {
          hasStep = true;
          break;
        }
      }

      if (hasStep) return;

      let targetId = node.id;
      try {
        const modeler = ctx && ctx.modeler;
        const canvas = modeler && modeler.get && modeler.get("canvas");
        const root = canvas && canvas.getRootElement && canvas.getRootElement();
        if (root && root.id) {
          targetId = root.id;
        }
      } catch {}

      reporter.report(targetId, "Diagram must contain at least one step/task element.");
    }
  };
};
